import { useQuery } from "@tanstack/react-query";
import { planService } from "../services/planService";
import type { ActivePlansResponse } from "@/types/profile";

export const useActivePlans = () => {
  return useQuery<ActivePlansResponse>({
    queryKey: ["plans", "active"],
    queryFn: planService.getActivePlans,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
